import HolographicCard from '@/components/base/HolographicCard';

export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center pt-20">
      <div className="container mx-auto px-6 text-center relative z-10">
        <div className="max-w-6xl mx-auto">
          <div className="p-12 md:p-16">
            <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight text-center font-orbitron">
              <span
                className="text-white block w-full text-center"
                style={{
                  textShadow: `
                    -1px -1px 0 #8b5cf6, 1px -1px 0 #8b5cf6,
                    -1px 1px 0 #8b5cf6, 1px 1px 0 #8b5cf6,
                    -2px -2px 0 #06b6d4, 2px -2px 0 #06b6d4,
                    -2px 2px 0 #06b6d4, 2px 2px 0 #06b6d4
                  `,
                }}
              >
                Fieldscale
              </span>
            </h1>

            <p className="text-lg md:text-xl mb-12 font-semibold tracking-widest text-white text-center font-sans uppercase">
              Governed Intelligence Systems
            </p>

            <a
              href="#genesisos"
              className="whitespace-nowrap px-8 py-4 bg-gradient-to-r from-cyan-400 to-purple-500 text-white font-semibold rounded-lg hover:shadow-lg hover:shadow-cyan-400/25 transition-all duration-300 cursor-pointer"
            >
              Explore Our Work
            </a>
          </div>
        </div>
      </div>

      {/* Floating elements */}
      <div className="absolute top-1/4 left-10 w-32 h-32 bg-gradient-to-br from-cyan-400/10 to-transparent rounded-full blur-xl animate-pulse"></div>
      <div className="absolute bottom-1/4 right-10 w-24 h-24 bg-gradient-to-br from-purple-400/10 to-transparent rounded-full blur-xl animate-pulse delay-1000"></div>
      <div className="absolute top-1/2 left-1/4 w-2 h-2 bg-cyan-400 rounded-full animate-ping"></div>
      <div className="absolute top-1/3 right-1/3 w-1 h-1 bg-purple-400 rounded-full animate-ping delay-500"></div>
    </section>
  );
}
